import { isCarInUse } from "_helperFunctions/isCarInUse";
import { carType, memberCarTrackingLevel, isUserSupport, isUserAdmin } from "constant";

export const filterCars = (
  allCarData,
  selectAll,
  fleetCars,
  marshalCars,
  specialCars,
  memberCars,
  beverageCars,
  notInUseCars,
  notCommunicatingCars,
  outsidePerimeterCars,
  taggedCars,
  mapsData,
  siteSettingsData,
  getUserRole,
  getHoleAreasState,
  getSiteAreasState,
  getCarPathActionZone
) => {
  let temp = [...allCarData];

  if (selectAll) temp = [...allCarData];
  if (
    !selectAll &&
    !fleetCars &&
    !marshalCars &&
    !specialCars &&
    !memberCars &&
    !beverageCars &&
    !notCommunicatingCars &&
    !notInUseCars
  ) {
    temp = [];
  }
  const pointInPolygon = (point, polygon, longitudePropertyName, latitudePropertyName) => {
    var x = point[0], y = point[1];
    var inside = false;
    for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      var xi = polygon[i][longitudePropertyName], yi = polygon[i][latitudePropertyName];
      var xj = polygon[j][longitudePropertyName], yj = polygon[j][latitudePropertyName];

      var intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  };
  const isCarInsideGeofence = (car) => {
    let actionZones = getCarPathActionZone?.filter((az) => {
      return az.IsGeofence;
    })
    if (!actionZones || Object.keys(actionZones).length <= 0) {
      return false;
    }
    var point = [car?.Car?.Longitude, car?.Car?.Latitude];
    var inside = pointInPolygon(point, actionZones[0].AzVertexes, 'Longitude', 'Latitude');
    return inside;
  }
  function isCarOnCourse(car) {
    let point = [car?.Car?.Longitude, car?.Car?.Latitude];
    for (let i = 0; i < getSiteAreasState?.length; i++) {
      if (pointInPolygon(point, getSiteAreasState[i]?.Polygon, "Lon", "Lat")) {
        return true;
      }
    }

    for (let i = 0; i < getHoleAreasState?.length; i++) {
      if (pointInPolygon(point, getHoleAreasState[i]?.Polygon, "Lon", "Lat"))
        return true;
    }
    return false;
  }
  if (!outsidePerimeterCars && mapsData && siteSettingsData) {
    temp = temp.filter((item) => {
      var lowerRightLatitude =
        siteSettingsData.UpperLeftLatitude -
        2 *
        (siteSettingsData.UpperLeftLatitude -
          siteSettingsData.CenterPointLatitude);

      const bounds = {
        sw: {
          lat: lowerRightLatitude,
          lng: siteSettingsData.UpperLeftLongitude,
        }, // southwest corner
        ne: {
          lat: siteSettingsData.UpperLeftLatitude,
          lng: lowerRightLatitude,
        }, // northeast corner
      };

      let inside = isPointInsideBounds(
        {
          lat: item.Car.Latitude,
          lng: item.Car.Longitude,
        },
        bounds
      );

      return inside;
    });
  }
  if (memberCars && !(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))) {
    {
      if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.Never) {
        temp = temp.filter((car) => car?.Car?.CarType !== carType.member);
      }
      else if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.InsideGeoFence) {
        temp = temp.filter((car) => {
          if (car?.Car?.CarType === carType.member) {
            return isCarInsideGeofence(car);
          }
          else
            return true;
        }
        )
      }
      else if (siteSettingsData?.MemberCarTrackingLevel === memberCarTrackingLevel.OnCourseOrPlayingGolf) {
        temp = temp.filter((car) => {
          if (car?.Car?.CarType === carType.member) {
            if (car?.Car?.HolesPlayed && car?.Car?.HolesPlayed != 0)  // Can be called to filter CarTrackInfo lists which don't have one
              return true;
            else
              return isCarOnCourse(car);
          }
          else
            return true;
        }
        )
      }
    }
  }

  if (!fleetCars) temp = temp.filter((item) => item.Car.CarType !== carType.normal);
  if (!marshalCars) temp = temp.filter((item) => item.Car.CarType !== carType.marshal);
  if (!specialCars) temp = temp.filter((item) => item.Car.CarType !== carType.handicap);
  if (!memberCars) temp = temp.filter((item) => item.Car.CarType !== carType.member);
  if (!beverageCars) temp = temp.filter((item) => item.Car.CarType !== carType.bevcart);
  if (!notCommunicatingCars) {
    temp = temp.filter((item) => {
      return item.Car.Connection !== 2;
    });
  }

  temp = temp.filter((item) =>
    isCarInUse(item.Car, notInUseCars, notCommunicatingCars, item.Car)
  );

  taggedCars.map((item) => {
    let taggedFound =
      allCarData && allCarData.find((i) => i.Car.CarNumber === item);
    if (taggedFound) {
      let tempFound = temp.find(
        (i1) => i1.Car.CarNumber === taggedFound.Car.CarNumber
      );
      if (!tempFound) temp.push(taggedFound);
    }
  });

  return temp;
};

const isPointInsideBounds = (point, bounds) => {
  const { lat, lng } = point;
  const { sw, ne } = bounds;
  return lat >= sw.lat && lat <= ne.lat && lng >= sw.lng && lng <= ne.lng;
};
